import { render, staticRenderFns } from "./EurProductRegistration.vue?vue&type=template&id=5f71c49b"
import script from "./EurProductRegistration.vue?vue&type=script&lang=js"
export * from "./EurProductRegistration.vue?vue&type=script&lang=js"
import style0 from "./EurProductRegistration.vue?vue&type=style&index=0&id=5f71c49b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports